import React from 'react';
import { motion } from 'framer-motion';
import Modal from './Modal';
import Button from './Button';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiTrash2, FiCheck, FiX } = FiIcons;

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger', // 'danger', 'warning', 'info'
  icon,
  loading = false
}) {
  const variants = {
    danger: { icon: FiTrash2, iconBg: 'bg-crimson/10', iconColor: 'text-crimson', confirmVariant: 'danger' },
    warning: { icon: FiAlertTriangle, iconBg: 'bg-goldenrod/10', iconColor: 'text-goldenrod', confirmVariant: 'warning' },
    info: { icon: FiCheck, iconBg: 'bg-skyblue/10', iconColor: 'text-skyblue', confirmVariant: 'primary' }
  };

  const config = variants[variant];
  const IconComponent = icon || config.icon;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" showCloseButton={false}>
      <div className="p-6 text-center">
        {/* Icon */}
        <div className={`w-16 h-16 ${config.iconBg} rounded-full flex items-center justify-center mx-auto mb-4`}>
          <SafeIcon icon={IconComponent} className={`w-8 h-8 ${config.iconColor}`} />
        </div>
        {/* Title */}
        <h3 className="text-xl font-cormorant font-bold text-charcoal mb-2">
          {title}
        </h3>
        {/* Message */}
        <p className="text-charcoal/70 font-dm-sans mb-6 leading-relaxed">
          {message}
        </p>
        {/* Actions */}
        <div className="flex gap-3 justify-center">
          <Button variant="secondary" onClick={onClose} disabled={loading} className="flex-1">
            {cancelText}
          </Button>
          <Button variant={config.confirmVariant} onClick={onConfirm} loading={loading} disabled={loading} className="flex-1">
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}